import React, { useState } from "react";
import Input from "theme/components/atoms/Form/Input/Input";
import Label from "theme/components/atoms/Form/Label/Label";
import IconButton from "theme/components/atoms/Button/IconButton";
import { defineMessages, useIntl } from "react-intl";
import PropTypes from "prop-types";

const messages = defineMessages({
  showPassword: {
    id: "components.atoms.Form.Input.Password.showPasswordTitle",
    defaultMessage: "Show password",
  },
  hidePassword: {
    id: "components.atoms.Form.Input.Password.hidePasswordTitle",
    defaultMessage: "Hide password",
  },
});

const Password = ({ disableShowPassword, ...props }) => {
  const [showPassword, setShowPassword] = useState(false);
  const intl = useIntl();

  function toggleShowPassword() {
    setShowPassword(!showPassword);
  }

  return (
    <div className="password">
      {props.label && <Label htmlFor={props.id}>{props.label}</Label>}
      <div className="password__input-container">
        <Input {...props} type={showPassword ? "text" : "password"} />
        {!disableShowPassword && (
          <div className={"password__show-icon"}>
            <IconButton
              icon={showPassword ? "eye-off" : "eye"}
              onClick={toggleShowPassword}
              type="button"
              iconSize="default"
              state={undefined}
              title={intl.formatMessage(
                showPassword ? messages.hidePassword : messages.showPassword
              )}
            />
          </div>
        )}
      </div>
    </div>
  );
};

Password.propTypes = {
  disableShowPassword: PropTypes.bool,
};

export default Password;
